import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { generateGruserObjectId } from '../helpers';
import privileges from './privileges';
import modules from './modules';
import layout from './layout';
import gruserReducer from './gruser';
import page from './page';
const defaultState = {};
export default ((state = defaultState, action)=>{
    const { gruser } = action.payload || {};
    if (!gruser) {
        return state;
    }
    const gruserObjectId = generateGruserObjectId(gruser);
    const gruserObjectSlice = state[gruserObjectId] || {};
    return _object_spread_props(_object_spread({}, state), {
        [gruserObjectId]: {
            privileges: privileges(gruserObjectSlice.privileges, action),
            modules: modules(gruserObjectSlice.modules, action),
            layout: layout(gruserObjectSlice.layout, action),
            gruser: gruserReducer(gruserObjectSlice.gruser, action),
            page: page(gruserObjectSlice.page, action)
        }
    });
});
